// /**
//  * App.js Layout Start Here (React Router v6 Compatible)
//  */
// import React, { Component } from 'react';
// import { connect } from 'react-redux';
// import { Routes, Route, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
// import { NotificationContainer } from 'react-notifications';

// // rct theme provider
// import RctThemeProvider from './RctThemeProvider';

// //Horizontal Layout
// import HorizontalLayout from './HorizontalLayout';

// // app signin
// import AppSignIn from './SigninFirebase';
// import AppSignUp from './SignupFirebase';
// import SetPassword from './SetPassword';
// import TravelAccept from './TravelAccept';
// import ParentAccept from './ParentAccept';

// //Auth0
// import Auth from '../Auth/Auth';

// // callback component
// import Callback from "Components/Callback/Callback";

// const auth = new Auth();

// const handleAuthentication = (location) => {
//    if (/access_token|id_token|error/.test(location.hash)) {
//       auth.handleAuthentication();
//    }
// };

// /**
//  * Higher Order Component to inject router props into class components
//  */
// function withRouter(Component) {
//    function ComponentWithRouterProp(props) {
//       let location = useLocation();
//       let navigate = useNavigate();
//       let params = useParams();
//       return (
//          <Component
//             {...props}
//             location={location}
//             navigate={navigate}
//             params={params}
//          />
//       );
//    }
//    return ComponentWithRouterProp;
// }

// class App extends Component {
//    render() {
//       const { location, user } = this.props;

//       // Redirect logic for root path
//       if (location?.pathname === '/') {
//          return user === null
//             ? <Navigate to="/signin" replace />
//             : <Navigate to="/app/dashboard" replace />;
//       }

//       return (
//          <RctThemeProvider>
//             <NotificationContainer />
//             <Routes>
//                {/* Protected Routes */}
//                <Route
//                   path="/app/*"
//                   element={
//                      user
//                         ? <HorizontalLayout />
//                         : <Navigate to="/signin" replace />
//                   }
//                />

//                {/* Public Routes */}
//                <Route path="/signin" element={<AppSignIn />} />
//                <Route path="/signup/:id" element={<AppSignUp />} />
//                <Route path="/setpassword/:id" element={<SetPassword />} />
//                <Route path="/travelaccept/:id/:usrid/:action" element={<TravelAccept />} />
//                <Route path="/parentaccept/:id/:usrid/:action" element={<ParentAccept />} />

//                {/* Callback */}
//                <Route
//                   path="/callback"
//                   element={
//                      <CallbackWrapper />
//                   }
//                />

//                {/* Fallback */}
//                <Route path="*" element={<Navigate to="/" replace />} />
//             </Routes>
//          </RctThemeProvider>
//       );
//    }
// }

// /**
//  * Callback wrapper to handle authentication
//  */
// function CallbackWrapper() {
//    const location = useLocation();
//    handleAuthentication(location);
//    return <Callback />;
// }

// // map state to props
// const mapStateToProps = ({ authUser }) => {
//    const { user } = authUser;
//    return { user };
// };

// export default connect(mapStateToProps)(withRouter(App));

/**
 * App.js Layout Start Here (React Router v6 Compatible)
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Routes, Route, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';

// rct theme provider
import RctThemeProvider from './RctThemeProvider';

//Horizontal Layout
import HorizontalLayout from './HorizontalLayout';
import Master from 'Routes/master';
import Sportsscience from 'Routes/sportsscience';
import Golf from 'Routes/golf';
import Travel from 'Routes/travelr';
import Contract from 'Routes/contract';
// app signin
import AppSignIn from './SigninFirebase';
import AppSignUp from './SignupFirebase';
import SetPassword from './SetPassword';
import TravelAccept from './TravelAccept';
import ParentAccept from './ParentAccept';

//Auth0
import Auth from '../Auth/Auth';

// callback component
import Callback from "Components/Callback/Callback";

const auth = new Auth();

const handleAuthentication = (location) => {
   if (/access_token|id_token|error/.test(location.hash)) {
      auth.handleAuthentication();
   }
};

/**
 * Higher Order Component to inject router props into class components
 */
function withRouter(Component) {
   function ComponentWithRouterProp(props) {
      let location = useLocation();
      let navigate = useNavigate();
      let params = useParams();
      return (
         <Component
            {...props}
            location={location}
            navigate={navigate}
            params={params}
         />
      );
   }
   return ComponentWithRouterProp;
}

class App extends Component {
   render() {
      const { location, user } = this.props;

      // Redirect logic for root path
      if (location?.pathname === '/') {
         if (user === null) {
            return <Navigate to="/signin" replace />;
         }

         const role = localStorage.getItem('user_role');
         const studentRole = localStorage.getItem('stdrole');
         let dashboardPath = '/app/dashboard';
         if (role == 12) {
            dashboardPath = '/app/parentdashboard';
         } else if (role == 14) {
            dashboardPath = '/app/commondashboard';
         } else if (studentRole == 1) {
            dashboardPath = '/app/studentdashboard';
         }

         return <Navigate to={dashboardPath} replace />;
      }

      return (
         <RctThemeProvider>
            <NotificationContainer />
            <Routes>
               {/* Protected Routes */}
               <Route
                  path="/app/*"
                  element={
                     user
                        ? <HorizontalLayout />
                        : <Navigate to="/signin" replace />
                  }
               />

               
              {/* Master */}
{/* <Route path="/app/master/*" element={<Master />} />
<Route path="/app/sportsscience/*" element={<Sportsscience />} />
<Route path="/app/golf/*" element={<Golf />} />
<Route path="/app/travel/*" element={<Travel />} />
<Route path="/app/contract/*" element={<Contract />} /> */}



{/* Public Routes */}
<Route path="/signin" element={<AppSignIn />} />
<Route path="/signup/:id" element={<AppSignUp />} />
<Route path="/setpassword/:id" element={<SetPassword />} />
<Route path="/travelaccept/:id/:usrid/:action" element={<TravelAccept />} />
<Route path="/parentaccept/:id/:usrid/:action" element={<ParentAccept />} />


{/* Callback */}
<Route
   path="/callback"
   element={<CallbackWrapper />}
/>

{/* Fallback */}
<Route path="*" element={<Navigate to="/" replace />} />

            </Routes>
         </RctThemeProvider>
      );
   }
}

/**
 * Callback wrapper to handle authentication
 */
function CallbackWrapper() {
   const location = useLocation();
   handleAuthentication(location);
   return <Callback />;
}

// map state to props
const mapStateToProps = ({ authUser }) => {
   const { user } = authUser;
   return { user };
};

export default connect(mapStateToProps)(withRouter(App));

